module.exports = __webpack_public_path__ + "static/rg-03-276babb9207221397c3555e78711fa27.jpg";